'use client';
import { jsx } from 'react/jsx-runtime';
import { useOverlayTrigger } from '@react-aria/overlays';
import { useOverlayTriggerState } from '@react-stately/overlays';
import { useRef, useId, useMemo } from 'react';
import { SwanPopoverContextProvider } from './popover.context.js';
import { useComponentStylesLoaded } from '../../hooks/use-component-styles-loaded.js';
import { useModeExtractor } from '../../hooks/use-mode-extractor/index.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
import { assignRefs } from '../../../core/utilities/ref.utils.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function _object_spread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {}, o = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), o.forEach(function(r) {
            _define_property(e, r, t[r]);
        });
    }
    return e;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        t.push.apply(t, o);
    }
    return t;
}
function _object_spread_props(e, r) {
    return r = null != r ? r : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys(Object(r)).forEach(function(t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    }), e;
}
function _object_without_properties(e, r) {
    if (null == e) return {};
    var t, o, n = _object_without_properties_loose(e, r);
    if (Object.getOwnPropertySymbols) {
        var p = Object.getOwnPropertySymbols(e);
        for(o = 0; o < p.length; o++)t = p[o], !(r.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (n[t] = e[t]);
    }
    return n;
}
function _object_without_properties_loose(e, r) {
    if (null == e) return {};
    var t, o, n = {}, p = Object.keys(e);
    for(o = 0; o < p.length; o++)t = p[o], r.indexOf(t) >= 0 || (n[t] = e[t]);
    return n;
}
const Popover = renderWithRef('Popover', null, (s, b)=>{
    useComponentStylesLoaded('Popover', SWAN_STYLE_KEY_MAP.popover);
    let { position: m = 'top', children: y } = s, O = _object_without_properties(s, [
        "position",
        "children"
    ]), j = useRef(null), _ = assignRefs(b, j), d = useRef(null), v = useId(), w = useOverlayTriggerState({}), P = useModeExtractor(j, w.isOpen), { overlayProps: g, triggerProps: h } = useOverlayTrigger({
        type: 'dialog'
    }, w, d);
    return jsx(SwanPopoverContextProvider, {
        value: useMemo(()=>({
                modes: P,
                popoverRef: j,
                triggerRef: d,
                overlayState: w,
                overlayProps: g,
                triggerProps: _object_spread_props(_object_spread({}, h), {
                    id: v
                }),
                popoverPlacement: null != m ? m : 'top'
            }), [
            d,
            v,
            j,
            w,
            g,
            h,
            m,
            P
        ]),
        children: jsx(RenderComp, {
            root: "div",
            forwardedRef: _,
            classNames: [
                'swan-popover-container'
            ],
            props: O,
            children: y
        })
    });
});

export { Popover };
